// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const health = {
  health_section: {
    sihra_pdf:
      'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    hsa_hra_employer_contribution: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您的雇主每年将**',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '缴纳/匹配',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '**相应金额。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    plan_details: {
      planType: '计划类型',
      hdhpFootnote:
        '由于这是高免赔额健康计划,在保险公司支付非预防性护理费用之前,您需要自行承担所列免赔额的100%。',
      afterDeductible: '满足免赔额后',
    },
    hsa_plan_details: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您选择这个符合HSA资格的健康计划,您的雇主将',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '。您可以使用这笔资金来帮助支付医疗费用,未使用的部分可以保留。请查看下方的计划详情,了解雇主的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '如何帮助您节省开支。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    hsa_modal_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '虽然健康保险可以帮助您支付医疗费用,但它并不涵盖所有费用。健康储蓄账户(简称HSA)是为这些费用储蓄的绝佳方式。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '运作方式如下:',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '首先,在注册符合HSA资格的健康计划后,开设一个健康储蓄账户。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '接下来,选择一个缴款金额,该金额将从您的工资中扣除。一些雇主也会向您的HSA缴款来帮助您。您今年未使用的任何资金都归您所有,即使您换工作也是如此。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '以下是您应该了解的其他事项:',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '您可以使用HSA支付符合条件的医疗费用,包括医疗共付额、视力和牙科费用、处方药等。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '您向HSA缴纳的任何资金都会降低您的税款。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '2022年,个人每年最多可缴款',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'text',
                      value: '{x}',
                      marks: [
                        {
                          type: 'code',
                        },
                      ],
                      data: {},
                    },
                    {
                      nodeType: 'text',
                      value: ',家庭每年最多可缴款',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'text',
                      value: '{x}',
                      marks: [
                        {
                          type: 'code',
                        },
                      ],
                      data: {},
                    },
                    {
                      nodeType: 'text',
                      value: '。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '随着您的余额增长,您可以投资这笔资金。最棒的是,任何收益以及用于符合条件费用的任何提款都是免税的。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '请务必仔细查看您的计划详情以获取更多信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    secondary_content: {
      contentful_name: '[DEFAULT] [Health] Secondary Content ',
      explore_our_predictions_cta: '了解更多关于ALEX如何计算您的个性化计划匹配度。',
      explore_our_predictions_button_text: '查看您的明细',
      build_a_plan_cta: '还需要考虑配偶或伴侣的计划?ALEX可以帮您进行比较。',
      build_a_plan_button_text: '家庭套餐对比',
      build_a_plan_instructions_button_text: '您需要准备的物品',
      build_a_plan_instructions_button_link:
        'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_Chinese-2023-12-05.pdf',
      waive_coverage_cta: '不需要雇主健康计划?',
      waive_coverage_button_text: '放弃保障',
      hsa_hra_fsa_cta: '了解有关这些储蓄和支出账户的更多信息。',
      hsa_button_text: 'HSA',
      hra_button_text: 'HRA',
      fsa_button_text: 'FSA',
      hsa_modal: {
        contentful_name: '[DEFAULT] HSA Educational Modal',
        title: '健康储蓄账户',
        header: {
          text: '什么是HSA?',
          subtext:
            '虽然健康保险有助于支付医疗费用,但它并不能涵盖所有费用。健康储蓄账户(HSA)是为这些费用储蓄的绝佳方式。',
        },
        eligible_plan_message: {
          contentful_name: '[DEFAULT] HSA Educational Modal - Eligible Plan',
          header: '您已选择符合HSA资格的计划!',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以在下一页决定捐款金额。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        non_eligible_plan_message: {
          contentful_name: '[DEFAULT] HSA Educational Modal - Non-Eligible Plan',
          header: '您尚未选择符合HSA资格的计划。',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '如果您这样做,ALEX 可以帮助您确定应缴纳多少金额。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
        employer_contribution_selected_plan_message: {
          contentful_name: '[DEFAULT] HSA Educational Modal - Employer Contribution Plan selected',
          header: '您的雇主将向您的HSA账户缴纳{x}',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以使用这些资金支付以下列出的符合条件的费用。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
        employer_contribution_no_selected_plan_message: {
          contentful_name: '[DEFAULT] HSA Educational Modal - Employer Contribution No Plan selected',
          header: '您的雇主将为您的健康储蓄账户(HSA)缴纳最多{x}',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以使用这些资金支付以下列出的符合条件的费用。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
        video_url: 'https://vimeo.com/813319552',
        how_does_it_work_header_text: '它是如何工作的?',
        how_does_it_work_content: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'unordered-list',
              content: [
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '选择符合HSA资格的健康计划。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '选择在HSA中存入多少金额(ALEX将帮助您完成)。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '您和您的雇主合计每年最多可缴存至联邦限额。2026年的限额为:- 个人:',
                          marks: [],
                          data: {},
                        },
                        {
                          nodeType: 'text',
                          value: '{x}',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'code',
                            },
                          ],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '家庭:',
                          marks: [],
                          data: {},
                        },
                        {
                          nodeType: 'text',
                          value: '{x}',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'code',
                            },
                          ],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        what_can_it_do_header_text: '它能做什么?',
        what_can_it_do_content: [
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Content Block - Lower Your Taxes',
            title: '降低您的税负',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '您向HSA账户存入的资金无需缴税。这意味着您可以通过向HSA账户存钱来降低您的税负。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name:
              '[DEFAULT] HSA Educational Modal Content Block - Pay for qualified medical expenses',
            title: '支付符合条件的医疗费用',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '使用您的免税HSA供款来支付符合条件的医疗费用。在此查看完整的合格费用清单:',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text: '符合条件的费用清单',
            button_link: 'https://www.irs.gov/pub/irs-pdf/p502.pdf',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - Invest For Retirement',
            title: '为退休投资',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '投资您的HSA资金,为退休后的医疗保健费用做好准备。投资收益和用于支付合格医疗费用的提款也无需纳税。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - Contributions',
            title: '供款归您所有',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '您对健康储蓄账户(HSA)的任何缴款都归您所有。您永远不必担心在年底失去您的HSA资金。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
        ],
        faq_header_text: '常见问题',
        faq_content: [
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - Contribute to HSA',
            title: '我如何向HSA账户存款?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '有两种缴款方式:一种是通过工资扣除,即在税前从您的工资中扣除缴款;另一种是从您的支票账户或储蓄账户直接转账。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - Use HSA',
            title: '如何使用我的HSA账户资金?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '当您开设HSA账户时,您将收到一张借记卡,可用于支付符合条件的医疗费用。您可以使用此借记卡直接向医疗保健提供者付款,也可以通过您的保险公司网站提交这些付款。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name:
              '[DEFAULT] HSA Educational Modal Custom Block - FAQ - HSA, 401(k), IRA Difference',
            title: 'HSA、401(k)、IRA:有什么区别?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'https://picwellapppublicdata.s3.amazonaws.com/secondary_educational_content/hsa_401k_hra_difference_en.png',
            cells: [
              ['', 'HSA', '401(k)', 'IRA'],
              ['供款免税', 'X', '401(k)供款不免除社会保障税和医疗保险税。', ''],
              ['资本收益免税', 'X', '延税', '仅限罗斯IRA'],
              ['提款免税', '如用于合格医疗费用', '仅限罗斯401(k)', '仅限罗斯IRA'],
              ['最低分配要求', '', 'X', '罗斯IRA除外'],
            ],
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - No Future Enrollment',
            title: '如果我将来不参加符合HSA资格的计划怎么办?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '一旦您将资金存入健康储蓄账户(HSA),即使您不再参加高免赔额健康计划,该账户也可用于免税支付符合条件的医疗费用。但是,您将无法进行新的存款。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - Laid Off',
            title: '如果我换工作或被裁员,我的HSA/资金会怎样?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '您的HSA账户中的资金始终归您所有,即使您失业或离职后也是如此。您通常可以将这笔钱保留在前雇主的HSA账户中,或者将其转入另一个HSA管理机构。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - Retired',
            title: '退休后我的健康储蓄账户(HSA)会怎样?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '一旦您年满65岁,无论您是否参加了Medicare医疗保险,从HSA账户中提取资金都不会受到罚款。如果您提取资金用于符合条件的医疗费用,则无需缴纳任何税款。HSA资金用于其他目的时,将按普通收入征税,就像401(k)提款一样。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
          },
          {
            contentful_name: '[DEFAULT] HSA Educational Modal Custom Block - FAQ - On Medicare',
            title: '如果我参加了Medicare,还能使用HSA吗?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '一旦您加入Medicare的任何部分,您就不能再向HSA账户缴款,您的雇主也不能。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '但是,您仍然可以免税提取资金用于符合条件的医疗费用。在您年满65岁后,您甚至可以使用HSA资金支付Medicare保费(Medigap除外)。如果您已经在HSA中投资资金,可以继续这样做。任何收益、利息或盈利仍然免税。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '您应该在Medicare保障开始之前停止向HSA缴款,否则可能需要支付税务罚款。如果您决定延迟注册A部分,您的保障可以追溯至最多六个月前生效,因此您应该计划在追溯保障生效之前停止缴款,否则您将支付同样的税务罚款。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
        ],
      },
      hra_modal: {
        contentful_name: '[DEFAULT] HRA Educational Modal',
        title: '健康报销账户',
        header: {
          text: '什么是HRA?',
          subtext:
            '健康报销安排(HRA)是雇主对您的一项承诺,即在规定的限额内承担您的医疗费用。当您注册符合HRA资格的计划时,您可以获得该限额内任何符合条件的医疗费用的报销。',
        },
        eligible_plan_message: {
          contentful_name: '[DEFAULT] HRA Educational Modal - Eligible Plan',
          header: '您已选择符合HRA资格的计划!',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'blue',
          icon: 'Check',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        non_eligible_plan_message: {
          contentful_name: '[DEFAULT] HRA Educational Modal - Non-Eligible Plan',
          header: '您尚未选择符合HRA资格的计划。',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          icon: 'Circle',
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
        employer_contribution_selected_plan_message: {
          contentful_name: '[DEFAULT] HRA Educational Modal - Employer Contribution Plan selected',
          header: '您的雇主将向您的健康报销账户(HRA)报销最多 {x}',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以使用这些资金支付以下列出的符合条件的费用。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'blue',
          icon: 'Check',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        employer_contribution_no_selected_plan_message: {
          contentful_name: '[DEFAULT] HRA Educational Modal - Employer Contribution No Plan selected',
          header: '您的雇主将向您的健康报销账户(HRA)报销最多 {x}',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以使用这些资金支付以下列出的符合条件的费用。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'blue',
          icon: 'Check',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        video_url: 'https://vimeo.com/813319594',
        how_does_it_work_header_text: '它是如何工作的?',
        how_does_it_work_content: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'unordered-list',
              content: [
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '一旦您选择符合 HRA 资格的健康计划,您的雇主将提供最多 ',
                          marks: [],
                          data: {},
                        },
                        {
                          nodeType: 'text',
                          value: '{x}',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'code',
                            },
                          ],
                          data: {},
                        },
                        {
                          nodeType: 'text',
                          value: ' 的资金,您可以使用这些资金来抵消您的医疗费用。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '当您接受医疗护理或购买符合 HRA 报销资格的物品时,请向您的雇主提交收据。如果您的雇主为您提供 HRA 借记卡,您也可以使用该卡支付符合条件的费用。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '您的雇主将从 HRA 资金中向您报销,直到您达到 HRA 资金限额为止。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '某些 HRA 计划可能允许您将一定数额的未使用资金结转到下一年,但您需要查看您的计划详情以了解具体情况。任何超过限额的资金将在计划年度结束时返还给您的雇主。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        what_can_it_do_header_text: '它能做什么?',
        what_can_it_do_content: [
          {
            contentful_name: '[DEFAULT] HRA Educational Modal Content Block - Qualified Medical Expenses',
            title: '支付符合条件的医疗费用',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '使用您雇主提供的HRA资金来支付符合条件的医疗费用。您的雇主决定具体的符合条件费用清单,但通常包括您的健康保险计划不承保的费用,例如共付额和免赔额支付,以及视力和牙科护理、非处方药和许多常见的家庭健康用品。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
        ],
        faq_header_text: '常见问题',
        faq_content: [
          {
            contentful_name: '[DEFAULT] HRA Educational Modal Custom Block - FAQ - Can I Contribute',
            title: '我可以向HRA供款吗?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '不可以。只有您的雇主可以向健康报销账户(HRA)缴款。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
            button_link:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
          {
            contentful_name: "[DEFAULT] HRA Educational Modal Custom Block - FAQ - I Didn't Use My Funds",
            title: '如果我没有用完所有的HRA资金会怎样?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '未使用的资金通常会退还给您的雇主,但请查看您的计划详情。在某些情况下,您的雇主可能允许您将部分未使用的资金结转到下一个计划年度。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] HRA Educational Modal Custom Block - FAQ - Access Funds',
            title: '如何使用我的HRA资金?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '如果您的雇主为您提供了HRA借记卡,您可以使用该卡支付符合HRA资格的费用。如果您没有HRA借记卡,您可以向雇主提交收据以获得报销。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
          {
            contentful_name: '[DEFAULT] HRA Educational Modal Custom Block - FAQ - Left Company',
            title: '如果我在年中离开公司会怎样?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '如果您在年中离开公司,您将无法使用健康报销账户(HRA)中剩余的任何资金。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] HRA Educational Modal Custom Block - FAQ - Expense Types',
            title: '哪些类型的费用可以从HRA报销?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '您可以使用HRA资金支付符合条件的医疗费用,包括共付额和共同保险、牙科和视力护理等多项费用。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text: '符合条件的费用清单',
            button_link: 'https://www.irs.gov/pub/irs-pdf/p502.pdf',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
        ],
      },
      fsa_modal: {
        contentful_name: '[DEFAULT] FSA Educational Modal',
        title: '医疗保健弹性支出账户',
        header: {
          text: '什么是FSA?',
          subtext:
            '医疗保健灵活支出账户(FSA)是一种税前账户,您可以使用它来支付健康保险计划未涵盖的合格医疗、牙科和视力费用。',
        },
        eligible_plan_message: {
          contentful_name: '[DEFAULT] FSA Educational Modal - Eligible Plan',
          header: '您有资格使用医疗保健FSA账户。',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'green',
          icon: 'Check',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        non_eligible_plan_message: {
          contentful_name: '[DEFAULT] FSA Educational Modal - Non-Eligible Plan',
          header: '由于您选择了带有HSA的计划,您有资格使用有限用途医疗保健FSA。',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'green',
          icon: 'Check',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        employer_contribution_no_selected_plan_message: {
          contentful_name: '[DEFAULT] FSA Educational Modal - Employer Contribution No Plan selected',
          header: '您的雇主将向您的医疗保健FSA账户缴纳{x}',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您可以使用这些资金支付以下列出的符合条件的费用。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
        video_url: 'https://vimeo.com/813319704',
        how_does_it_work_header_text: '它是如何工作的?',
        how_does_it_work_content: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'unordered-list',
              content: [
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '开设账户并决定每年缴存多少金额。您的雇主将计算从每次工资中扣除多少金额,以达到您的年度总缴存额。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '您必须在开设账户时决定缴存金额。您将立即获得全年总额度的使用权限,即使您将通过每次工资逐步缴存这些金额。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '完成后,您可以使用账户帮助支付数百种符合条件的医疗保健费用,例如看医生的共付额、处方药以及新眼镜或隐形眼镜。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '如果您没有用完所有FSA资金,您可能可以将部分未使用的资金结转到下一个计划年度,但您将损失超过该结转限额的任何剩余缴存金额。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value: '由于您可能会损失未使用的FSA资金,因此您应该只缴存您确定会使用的金额。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'list-item',
                  content: [
                    {
                      nodeType: 'paragraph',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            '如果您参加了符合HSA资格的计划,您的医疗保健FSA将转变为有限用途FSA。有限用途FSA只能用于支付牙科、视力和正畸费用。',
                          marks: [],
                          data: {},
                        },
                      ],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        what_can_it_do_header_text: '它能做什么?',
        what_can_it_do_content: [
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Content Block - Lower Your Taxes',
            title: '降低您的税负',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '您向FSA账户缴纳的款项无需纳税。这意味着您可以通过向FSA账户存钱来降低您的税负。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Content Block - Qualified Medical Expenses',
            title: '支付符合条件的医疗费用',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '使用您的免税FSA供款来支付符合条件的医疗费用。在此查看完整的合格费用清单:',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text: '符合条件的费用清单',
            button_link: 'https://www.irs.gov/pub/irs-pdf/p502.pdf',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
        ],
        faq_header_text: '常见问题',
        faq_content: [
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - Can I Contribute',
            title: '我可以向FSA账户缴款吗?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '可以。您可以向FSA(灵活支出账户)缴款。由于FSA缴款免税,这是一种很好的方式,可以在您知道将会产生的符合条件的费用上获得税收减免。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - How Much Can I Contribute',
            title: '我可以向FSA账户缴纳多少钱?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '2026年,联邦FSA供款限额为每年3,400美元,但您的雇主可能会设定不同的限额,因此请务必查看您的计划详情。请务必只供款您确定会使用的金额,因为年底未使用的FSA资金可能会被没收。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - Can I Change My Mind',
            title: '我可以更改FSA的缴款金额吗?',
            content: {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '不可以。一旦您设定了供款金额,除非发生特定的符合资格的生活事件,否则无法更改供款金额。符合资格的生活事件包括结婚或离婚、家庭新增子女或就业状况发生变化等情况。',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'document',
            },
            button_text:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          },
          {
            contentful_name: "[DEFAULT] FSA Educational Modal Custom Block - FAQ - Didn't Use Funds",
            title: '如果我没有用完FSA账户中的所有资金会怎样?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '未使用的资金通常会退还给您的雇主,但请查看您的计划详情。美国国税局允许雇主将最多680美元的未使用资金结转到下一个计划年度。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - Access Funds',
            title: '我如何使用我的FSA资金?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '您的雇主可能会为您提供FSA借记卡,您可以使用该卡支付符合条件的费用。您也可以申请从您的账户中报销符合条件的费用。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - Leave Job',
            title: '如果我在年中离开公司会怎样?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '如果您在年中离开公司,您可能会有一个"用完期限",在此期间您在离职后仍可以使用FSA资金。在该用完期限内未使用的任何资金都将被没收。请向您的雇主咨询更多详情。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text:
              'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
            button_link:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
          {
            contentful_name: '[DEFAULT] FSA Educational Modal Custom Block - FAQ - Expense Types',
            title: '我可以使用FSA支付哪些类型的费用?',
            content: {
              nodeType: 'document',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '使用您的免税FSA供款来支付符合条件的医疗费用。在此查看完整的合格费用清单:',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
            },
            button_text: '符合条件的费用清单',
            button_link: 'https://www.irs.gov/pub/irs-pdf/p502.pdf',
            image_url:
              'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          },
        ],
      },
      member_selection_mobile_header: {
        everyone: '覆盖所有成员',
        yourself: '覆盖您自己',
        familyMembers: '覆盖 {x} 名成员',
      },
      member_selection_header: '您要为谁投保?',
      member_overage_dependent_disclaimer: {
        contentful_name: '[DEFAULT] Overage Dependent Disclaimer',
        header: '注意!',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的医疗保险对受抚养人有年龄限制。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      tooltips: {
        memberSelectionHeader: {
          text: '选择您将在健康保险计划中覆盖的人员。您的预测费用和ALEX的计划排名将自动更新。',
          title: '家庭保障范围',
        },
        continue_button_tooltip: {
          text: '注意:每个医疗服务提供者的网络状态可能随时变化,因此建议您在下次预约前联系他们,确认他们是否仍在网络内。',
        },
        providerSelectionHeader: {
          text: '创建您的医生和其他医疗服务提供者列表,以了解哪些计划将他们纳入网络内。',
        },
      },
      member_selection_info_bar: {
        contentful_name: '[Health] Member Selection Info Bar',
        header:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated, and I will immediately generate the translation for you.',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '如果您更新家庭成员信息,则需要重新添加自选计划详情。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      member_selection_pregnancy_save: '保存答案',
      member_selection_update_button: '更新成员',
      accessibility: {
        loading_bar_alert: '正在分析您符合条件的计划',
        plan_selected_alert: '已选择计划',
        waived_coverage_alert: '已放弃保障',
        loading_bar_complete_alert: '您的计划已准备就绪',
        compare_modal_add_plan_alert: '已选择 {x}',
        compare_bar_remove_plan_button: '移除计划',
        compare_modal_remove_plan_alert: '已移除 {x}',
      },
      member_selection_pregnancy_question: '您已更新承保对象。您的承保家庭成员是否计划在未来一年内怀孕?',
      member_selection_modal_incentives_prompt: '让我们确认这些答案对于您要承保的人员仍然准确。',
      member_selection_modal_header: '更新个人资料问题',
      provider_selection_header: '医生和医疗服务提供者',
      provider_selection_add_button: '添加提供商',
      provider_selection_update_button: '更新提供商',
      provider_selection_cta_no_providers: '尚未添加医生或医疗服务提供者。',
      provider_selection_accepting_new_patients: '接受新患者',
      in_network_providers_heading: '网络内医疗服务提供者',
      none_added: '未添加',
      no_deductible_modal: {
        contentful_name: '[DEFAULT] NoDeductible Educational Modal',
        title: '标题',
        header: {
          text: '{x}的运作方式',
          para_2:
            '{x}的运作方式略有不同。医疗服务提供者根据质量、经验和价值被评为绿色、黄色或红色。您可以使用专门的网站或应用程序查看这些评级,并货比三家,找到最适合您需求的医疗服务提供者。',
          para_3:
            '总的来说,这些计划让管理和了解您的支出变得更容易一些——您看到的价格就是您支付的价格,无需满足免赔额或计算百分比。',
          subtext: '对于大多数健康保险计划,您先接受医疗服务,之后才知道费用是多少。',
          para_2_surest:
            '{x}的运作方式略有不同。您可以使用专门的网站或应用程序查看网络内的预付价格。这样,您就可以货比三家,为所需的医疗服务找到最优惠的价格。',
          para_3_additional_text:
            '此外,您每月月底会收到一份账单,上面汇总了您所有的医疗保健费用,这样一次性付清就容易多了。',
        },
        video_url: 'https://vimeo.com/1080669330/1bd6b1a5d0',
        how_does_it_work_header_text:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        how_does_it_work_content: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        what_can_it_do_header_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        faq_header_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      claims_banner_header: '您当前的医疗支出',
      claims_banner_subtext: '当前支出只是选择医疗计划时需要考虑的一个因素。',
      claims_banner_loading: '正在加载您的消费详情...',
      claims_banner_error: '我们无法获取您的消费详情。',
      claims_banner_button: '了解ALEX如何决策',
      claims_banner_oop_max: '自付最高限额',
    },
    no_employer_contribution_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '如果您选择符合HSA资格的健康计划,您可以进行税前供款来帮助支付医疗费用,并且可以保留未使用的部分用于支付未来的医疗保健费用。点击该计划,查看通过HSA支付自付费用可以节省多少税款。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    eligibility_text: {
      hra: {
        tag: '符合HRA资格',
        standardPlan: '这是一个符合HRA资格的计划。',
      },
      hsa: {
        tag: '符合HSA资格',
        standardPlan: '这是一个符合HSA资格的计划。',
        contributionPlan:
          '此计划允许您向HSA(健康储蓄账户)供款。您可以使用它来帮助支付医疗费用,未使用的部分可以保留。',
      },
      sihra: {
        tag: '符合SIHRA资格',
        standardPlan: '这是一个符合SIHRA资格的计划。',
      },
    },
    next_steps: {
      fbs: '接下来,让我们选择您的补充保障',
      noFbs: '让我们回顾一下您的选择',
      hsaPlus: '接下来,让我们了解一下您的健康储蓄账户。',
    },
    title_info_bar: {
      profileComplete: '太棒了,个人资料已完成!',
    },
    client_disclaimers: {
      resultPageSihra: {
        text: '加入您配偶的保险计划,您的雇主将向配偶激励HRA账户贡献最高{x}。',
        title: '符合配偶激励HRA资格',
      },
      resultPageCustom: [],
      resultPageSpousal: {},
      viewPlanPageSpousal: {},
      buildAPlanModalSihra: {
        note: '请注意:SIHRA福利不能与任何包括雇主或员工向HSA供款的配偶健康计划合并使用。HSA中已有余额不影响SIHRA的参与资格。',
        text: '加入您配偶的保险计划,您的雇主将向配偶激励HRA账户贡献最高{x}。',
        title: '符合配偶激励HRA资格',
      },
    },
    hra_modal_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您的健康保险计划附带健康报销安排(HRA)。HRA是由您的雇主设立并向其注资的账户,用于帮助您支付符合条件的自付医疗费用。这可能包括医疗共付额、视力和牙科费用、处方药等。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '运作方式如下:',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '一旦您注册符合HRA资格的计划,您的雇主将为您设立一个账户,您可以使用该账户来抵消您的医疗费用。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '当您接受医疗护理时,保险公司将从您的HRA中支付您医疗计划所涵盖的医疗账单,直到您用完所有分配的资金。根据您的雇主如何设置您的HRA,您可能需要提交收据以获得报销。但请记住,您的报销金额仅限于您的雇主为您的HRA提供的资金额度。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '以下是您应该了解的其他事项:',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '如果您没有用完所有HRA资金进行报销,您可能可以在未来几年使用这些资金,具体取决于您的雇主允许您结转的金额。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        '如果您决定注册不符合HRA资格的计划或离开当前雇主,您将失去雇主已注入的所有HRA资金。',
                      marks: [],
                      data: {},
                    },
                  ],
                  data: {},
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '请务必仔细查看您的计划详情以获取更多信息。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    button_text: {
      hra: '什么是HRA?',
      hsa: '什么是HSA?',
      card: '卡片',
      next: '继续',
      sihra: '什么是SIHRA?',
      table: '表格',
      review: '前往审核',
      compare: '比较',
      hsaPlus: '前往HSA',
      noPlans: '返回资格确认',
      planPdf: '计划PDF',
      allPlans: '返回所有计划',
      viewPlan: '查看详情',
      learnMore: '了解更多',
      choosePlan: '选择计划',
      noCoverage: '放弃保障',
      editProfile: '编辑个人资料',
      deselectPlan: '取消选择',
      selectedPlan: '已选择',
      showAllPlans: '显示所有计划',
      supplemental: '前往补充计划',
      insuranceModal: '更多健康保险信息',
      providerSearch: '搜索医疗服务提供者',
      summaryOfBenefits: '完整计划详情',
    },
    null_plan_detail_text: {
      deductibleAndOopMax: '不适用',
    },
    waive_coverage_text: '不想要健康保险?',
    oop_cost_receipt: {
      drugs: '处方药',
      hsaMatch: '雇主HSA配套供款',
      medicalCare: '医疗护理',
      oopEstimate: '自付费用估算',
      remainingOop: '剩余自付费用',
      hsaTaxSavings: 'HSA税收节省',
      hraContribution: '雇主HRA有效供款',
      hsaContribution: '雇主HSA供款',
      noReimburseCopay: 'HRA不涵盖共付额报销。',
      recommendedHsaContribution: '建议HSA供款',
    },
    hsahra_plan_details: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您选择此',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '符合条件的健康计划,您的雇主将',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '。您可以使用此项来帮助支付医疗费用,未使用的部分可以保留。请查看下方的计划详情,了解雇主的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '如何帮助您节省开支。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    breakdown_heading: '费用明细',
    contentful_name: 'Health Section (DEFAULT DO NOT CHANGE)',
    page_header: {
      text: '选择健康计划',
      subtext: '以下是您有资格选择的 {x} 个计划,按照它们与您个人医疗保健需求和偏好的匹配程度进行排序。',
      text_welcome: '欢迎回来!',
      text_alternate: '正在整理您的回答',
      text_review_tool: '查看 {x} 个符合条件的计划',
      subtext_review_tool: '验证这些计划并编辑个人资料以探索其他可能的资源',
      sortedtext_review_tool: '按 A 到 Z 排序',
      subtext_hide_plan_scoring: '以下是您有资格选择的 {x} 个计划。',
      previous_selected_plan_text: '您有资格选择 {x} 个计划。您上次选择的计划已在顶部突出显示。',
      subtext_hide_plan_scoring_alternate: '以下是您的医疗计划预估费用。',
      previous_selected_plan_text_alternate: '以下是您的医疗计划预估费用。上次您表示会注册。',
    },
    employer_involvement_options: {
      hsaMatch: 'HSA 配对',
      hraContribution: 'HRA 供款',
      hsaContribution: 'HSA 供款',
    },
    plan_details_heading: '计划详情',
    contribution_types: {
      hra: 'HRA',
      hsa: 'HSA',
      both: 'HSA & HRA',
      sihra: 'SIHRA',
      hra_sihra: 'HRA & SIHRA',
    },
    comprehensive_plan_terms: {
      drug: '药物',
      medical: '医疗',
    },
    summary_of_benefits: {
      heading: '需要更多详情?',
      subheading: '查看完整的计划详情PDF文档。',
    },
    text_note: {
      contentful_name: '[DEFAULT] Text Note',
      short_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      long_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '您提供的内容为空,没有需要翻译的文本。请提供需要从英语(美国)翻译成简体中文(中国)的具体内容。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      button_text: '阅读更多',
    },
    hsa_video: 'https://vimeo.com/499286061',
    hsa_reminder: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '重要的HSA提醒!',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您已选择符合HSA资格的医疗保健计划。请务必正确开设HSA账户,以充分利用HSA提供的各项优势。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    plans_heading: '您的健康计划',
    min_max_cost_sharing: {
      maxCostSharing: ' 最高 {x}',
    },
    no_plans_modal: {
      title: '无可用计划',
      description:
        '根据您对资格问题的回答,您不符合任何计划的资格条件。请确保您已正确回答这些资格问题,或联系您的人力资源部门了解更多详情。',
    },
    premium_cost_header: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '保费费用',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您将始终需要为此计划支付保费。',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    saved_plan_modal: {
      title: '健康计划已保存',
      disclaimer: '您可以随时返回更改您的计划。',
      loadingText: '正在保存您的健康计划',
    },
    compare_plan_text: {
      compareBar: {
        thirdPlan: '最多比较3个计划',
        secondPlan: '选择第二个计划',
      },
      compareModal: {
        copay: '定额共付',
        terms: {
          score: {
            term: '计划匹配度表示每个计划与您的个人医疗保健需求和风险保护偏好的契合程度。',
            title: '计划匹配度',
          },
          premium: {
            term: '使用通用提示定义',
            title: '保费',
          },
          planType: {
            term: '无提示',
            title: '计划类型',
          },
          brandDrug: {
            term: '使用通用提示定义',
            title: '品牌药定额共付或共同保险',
          },
          genericDrug: {
            term: '使用通用提示定义',
            title: '仿制药定额共付或共同保险',
          },
          oopEstimate: {
            term: '使用通用提示定义',
            title: '自付费用估算',
          },
          primaryCare: {
            term: '使用通用提示定义',
            title: '初级护理定额共付或共同保险',
          },
          specialtyDrug: {
            term: '使用通用提示定义',
            title: '特殊药物',
          },
          estYearlyTotal: {
            term: '使用通用提示定义',
            title: '预计年度总额',
          },
          specialistCare: {
            term: '使用通用提示定义',
            title: '专科护理定额共付或共同保险',
          },
          nonFormularyDrug: {
            term: '使用通用提示定义',
            title: '非处方集药物定额共付或共同保险',
          },
        },
        headers: {
          copays: '定额共付和共同保险',
          mainDetails: '主要详情',
          deductiblesLimits: '免赔额和限额',
        },
        oopLimit: '自付费用上限',
        perVisit: '每次就诊',
        inNetwork: '网络内',
        deductible: '免赔额',
        modalTitle: '比较您的计划',
        notCovered: '不承保',
        coinsurance: '共同保险',
        outOfNetwork: '网络外',
        selectThirdPlan: '提示:您最多可以同时比较3个计划。',
        preferredNetwork: '最优选',
        afterDeductibleAsterisk: '满足免赔额后',
        noShowRxOonCoverage: '详情请参阅计划文件',
        noRxOonCoverage: '处方药仅在网络内承保',
      },
    },
    provider_selection_modal: {
      title: '医生和医疗服务提供者',
      loading: '加载中...',
      location: '位置',
      locations: '位置',
      footer_text: '查看医疗服务提供者状态',
      save_button: '继续',
      zipcode_label: '邮政编码',
      add_button_cta: '添加',
      distance_label: '距离(英里)',
      cancel_button_cta: '取消',
      update_button_cta: '更新',
      search_placeholder: '搜索医生或医疗服务提供者',
      search_char_limit_cta: '请输入至少3个字符',
      search_no_results_cta: '无结果',
      select_location_label: '选择一个位置',
      create_list_description: '创建您的医生和其他医疗服务提供者列表,以了解哪些计划将他们纳入网络内。',
      zipcode_validation_error: '请输入有效的邮政编码',
    },
    hra_reminder: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '重要的HRA提醒!',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您已选择符合HRA资格的医疗保健计划。系统将自动为您设立账户。您无需执行任何额外操作即可使用此福利。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    oop_cost_header: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '自付费用估算',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '我们通过将您的答案与来自像您一样的数百万人的数据点进行比较来计算估算的自付费用。',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    other_plan_notes: {
      title: '其他计划说明',
      hsaEligible: {
        employerContribution:
          '在最终确定您的计划时,请务必查看您的雇主如何分配HSA供款。有时雇主会在全年分批发放资金,这意味着当您的计划开始时,资金可能无法全额用于支付您的医疗费用。',
        'oopEstimate_<_hsaLimit':
          '您可能需要考虑缴纳超过推荐金额的HSA供款,因为这将有助于应对未来的医疗保健费用。',
        'employerContribution_>_oopEstimate': {
          employer:
            '您的雇主HSA供款将覆盖您的预估自付费用。这将为您的HSA留下{remainder}({hsaContribution}减去{oopEstimate})的余额。这笔额外金额将保留在您的HSA中,直到您需要使用它。',
          personal:
            '您的个人HSA供款建议为$0,因为您雇主的HSA供款已覆盖您所有的预估自付费用。您随时可以向HSA追加资金以应对意外费用。',
        },
      },
      comprehensiveOopLimit:
        '您的最高自付费用上限为{oopLimit}。在最坏的情况下,您每年为承保服务支付的费用不会超过{oopLimit}。',
      comprehensiveInNetworkOopLimit:
        '您的最高自付费用上限为{inNetworkMax}。在最坏的情况下,您每年为网络内承保服务支付的费用不会超过{inNetworkMax}。',
    },
    hra_plan_details: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您选择此HRA合格健康计划,您的雇主将',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。您可以使用此项来帮助支付医疗费用。请查看下方的计划详情,了解雇主的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '如何帮助您节省开支。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    plan_cost_contributions: {
      oop: {
        no: '雇主{x}缴费不足以支付您的自付费用。',
        yes: '雇主{x}缴费将帮助您支付自付费用。',
      },
      premium: {
        no: '雇主{x}缴费不足以支付您的保费。',
        yes: '雇主{x}缴费将帮助您支付保费费用。',
      },
    },
    recommendation: {
      contentful_name: '[DEFAULT] Health Recommendation',
      yearly_expense_total: '年度支出总额',
      premium: '高级版',
      yearly_premium: '年度保费',
      deductible: '免赔额',
      out_of_pocket_estimate: '自付费用估算',
      out_of_pocket_max: '自付费用上限',
      view_details: '查看详情',
      choose_plan_button: '选择套餐',
      compare: '比较',
      unlimited: '无限制',
      unselect: '取消选择',
      hsa_info_with_contribution: {
        contentful_name: '[DEFAULT] HSA Info With Contribution',
        header: 'HSA适用',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的雇主每年将贡献最多',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'underline',
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'purple',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      hsa_info_with_employer_match: {
        contentful_name: '[DEFAULT] HSA Info With Employer Match',
        header: 'HSA适用',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的雇主将按',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'underline',
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '的比例匹配您的缴款,最高可达',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'underline',
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'purple',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      hsa_info: {
        contentful_name: '[DEFAULT] HSA Info',
        header: 'HSA适用',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '– 使用免税供款支付医疗账单。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'purple',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      hra_info_with_contribution: {
        contentful_name: '[DEFAULT] HRA Info With Contribution',
        header: '符合HRA资格',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的雇主每年将报销最多',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'underline',
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      },
      hra_info_no_contribution: '您已选择符合HRA资格的计划',
      fsa_info_with_contribution: {
        contentful_name: '[DEFAULT] FSA Info With Contribution',
        header: 'FSA合规',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的雇主每年将贡献最多 ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'green',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      fsa_info: {
        contentful_name: '[DEFAULT] FSA Info',
        header: 'FSA合规',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '– 使用免税供款支付医疗账单。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'green',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      sihra_info_with_contribution: {
        contentful_name: '[DEFAULT] SIHRA Info With Contribution',
        header: '符合SIHRA资格',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您的雇主每年将贡献最多',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{x}',
                  marks: [
                    {
                      type: 'underline',
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'CurrencyDollar',
        url_button_text:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      },
      placeholder_carrier_name:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      placeholder_plan_marketing_name: '缺少计划营销名称',
      plan_fit_labels: {
        contentful_name: '[default] Plan Fit Tiers',
        best_fit_label: '最佳匹配',
        great_fit_label: '合适',
        fair_fit_label: '合身',
        poor_fit_label: '不合适',
        best_fit_tooltip: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: '根据您预测的医疗保健需求和偏好,此计划可能最适合您。查看',
                  nodeType: 'text',
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  value: '{plan fit link}',
                  nodeType: 'text',
                },
                {
                  data: {},
                  marks: [],
                  value: '了解更多关于ALEX如何计算您的最佳匹配的信息。',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        great_fit_tooltip: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '根据您预测的医疗保健需求和偏好,这个计划对您来说看起来很有价值。查看',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{plan fit link}',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '了解更多关于ALEX如何计算您的最佳匹配的信息。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        fair_fit_tooltip: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    '根据您预测的医疗保健需求和偏好,这个计划看起来比较适合您。如果您选择评级为"良好匹配"或更高的计划,可能会获得更好的价值。查看',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{plan fit link}',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '了解更多关于ALEX如何计算您的最佳匹配的信息。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        poor_fit_tooltip: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    '根据您预测的医疗保健需求和偏好,您通过此计划最终省钱的可能性较低。如果您选择"适合"评级或更高评级的计划,您可能会获得更好的价值。查看',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '{plan fit link}',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '以了解更多关于ALEX如何计算您的最佳匹配的信息。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        plan_fit_link_text: '您的计划适配明细',
        why_button_text: '为什么?',
      },
      preferred_network_providers_heading: '最受欢迎',
      in_network_providers_heading: '网络内',
      in_network_providers_add_button: '添加提供商',
      in_network_providers_none: '无',
      in_network_providers_add_provider_text: '添加您的医疗服务提供者以查看他们是否在此计划的承保范围内。',
      invalidate_plan_message: {
        noPlanOffered: '您上次选择的计划已不再提供。',
        noLongerEligible: '您上次选择的计划已不再对您开放。',
        everyoneNotCovered:
          '您已更新了承保人员,因此某些计划详情可能已发生变化。请在继续之前确保一切仍符合您的需求。',
      },
      no_deductible_plan_callout: {
        text: '当您需要医疗服务时,您可以使用专门的网站或应用程序进行比较选择,该平台会根据质量、经验和价值对医疗服务提供者进行排名。我们使用常见的可用价格估算了您的潜在费用,但实际费用可能会因您选择的医疗服务提供者而有所不同。',
        header: '请记住——费用为估算值',
        buttonText: '了解更多',
        text_surest:
          '具体而言,您的自付费用估算是基于您所说可能需要的医疗服务的常见共付额。实际费用将取决于您选择的医疗服务提供者。',
        header_surest: '请记住——此计划允许您货比三家,因此费用为估算值',
        no_deductible_info:
          '当您需要医疗服务时,您可以使用专门的网站或应用程序进行比较选择,该平台会根据质量、经验和价值对医疗服务提供者进行排名。我们使用常见的可用价格估算了您下方的潜在费用,但实际费用可能会因您选择的医疗服务提供者而有所不同。',
        no_deductible_info_surest_text:
          '由于此计划允许您货比三家以获得最优惠的医疗保健价格,我们使用您所说需要的医疗服务的常见费用估算了您的潜在自付支出。',
      },
      hsa_balance: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '但您可以使用您的 ',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
              {
                nodeType: 'text',
                value: ' HSA 储蓄',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    loading_statuses: {
      '25%': '正在整理您的资料回复...',
      '50%': '正在整理您的资料回复...',
      '75%': '正在分析您符合条件的计划...',
      '100%': '正在分析您符合条件的计划...',
    },
    hra_video: 'https://vimeo.com/499286770',
    provider_search_text: {
      heading: '搜索医疗服务提供者',
      subheading: '在 {x} 的网络中查找医疗服务提供者。',
    },
    insurance_modal_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '医疗保险的基本理念是您预先支付一笔费用,称为保费,作为交换,您的保险计划将承担您部分医疗账单的费用。您的保险计划承担的金额取决于许多因素,这些因素可能会变得相当复杂。不过别担心!ALEX会为您查看所有这些细节,您无需操心。即便如此,您还是应该了解一些关键术语,这将帮助您理解医疗保险的运作方式。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '计划类型',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您可能已经注意到,在医疗保险领域有很多缩写词。',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'HMO',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '、',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'PPO',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '和',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'HDHP',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '都是描述您健康计划某些重要特征的缩写词。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'HMO',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '代表健康维护组织。HMO通常对您获得的医疗保健提供更多限制。在获得任何非急诊医疗护理之前,您需要从初级保健提供者那里获得转诊,并且非急诊网络外费用可能不予承保。承保部分网络外费用的HMO通常被称为**服务点(POS)**计划。HMO的优势在于这些限制旨在降低成本,因此您通常为这些类型的计划支付较低的保费。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'PPO',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '代表优选医疗机构组织。PPO不要求您为非急诊医疗护理获得转诊,并且与HMO相比,它们将为网络外护理提供更全面的承保。PPO在您获得医疗护理的方式上提供更大的灵活性,但您通常为这些类型的计划支付较高的保费。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'HDHP',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '代表高免赔额健康计划。HDHP的决定性特征是其免赔额,HMO或PPO计划都可以是HDHP。HDHP这个术语通常保留给免赔额高到足以与HSA配对的计划。在2022年,这意味着个人承保的免赔额至少需要达到1,400美元,家庭承保的免赔额至少需要达到2,800美元。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '保费',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您的保费是您为医疗保险支付的价格。一般来说,您支付的保费越多,当您收到医疗账单时,您的保险计划支付的就越多。高保费还经常与更广泛的医疗服务提供者网络以及看专科医生等事项的较少限制相关联。(我们稍后会介绍这些)。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '保费是免税的。这意味着如果您通过雇主获得医疗保险,您的保费将在您缴纳任何税款之前从您的工资中扣除。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '免赔额',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '免赔额',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                '定义了在您的保险开始承保费用之前您需要支付的金额。如果您的计划有1,000美元的免赔额,在您产生那么多医疗账单之前,您的保险不会开始承保您的任何医疗账单。即使您的计划确实有免赔额,预防性护理也始终从一开始就得到承保。这意味着即使您有高免赔额的计划,您也不必为疫苗接种、年度体检或婴儿健康检查等项目支付任何费用。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '一些健康计划对处方药和其他医疗护理有不同的免赔额。例如,如果一个计划对处方药的免赔额为0美元,对其他医疗护理的免赔额为1,000美元,这意味着您的保险立即开始承保处方药的费用。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '共付额和共同保险',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '共付额和共同保险定义了您支付医疗账单的多少。如果您的计划有免赔额,共付额和共同保险在您满足免赔额后生效。共付额是指您为医疗服务支付的固定金额,而共同保险是指您支付账单的百分比。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '*以下是几个例子。*假设您的健康计划对初级保健门诊收取20美元的共付额,对专科门诊收取10%的共同保险费率。如果您已经满足了免赔额,那么在这种情况下,无论最终账单是多少,您都将为初级保健预约支付20美元,但您为专科预约支付的金额将取决于账单。如果专科账单是400美元,您支付40美元,但如果账单是500美元,您支付50美元。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '自付费用(OOP)上限',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您的自付费用(OOP)是指在您将免赔额、共同保险和共付额相加后,您为医疗账单支付的总金额。您的健康计划的OOP上限对您每年负责支付的金额设置了上限。一旦您的免赔额、共同保险和共付额的总和达到OOP上限,您的健康计划将承保任何剩余的医疗账单。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '*以下是一个例子。*假设您病得很重,最终住院一周,累积了21,000美元的医疗账单。如果您有一个免赔额为1,000美元的健康计划,对住院收取20%的共同保险费率,并且OOP上限为3,000美元,以下是健康计划计算您付款的方式。首先,您将支付1,000美元,剩下20,000美元将由共同保险承保。您20%的共同保险费率将使您额外支付4,000美元的共同保险费用,但由于OOP上限将您的费用限制在3,000美元,您只需额外支付2,000美元的共同保险费用。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '药品目录',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '药品目录是一份处方药清单,定义了您的健康计划承保什么以及如何承保。如果处方不包含在药品目录中,您的医疗保险可能不予承保,这意味着您将负责支付该处方的全部费用。如果处方在药品目录中,那么您支付的金额将取决于该药物所在的层级。药品目录通常对仿制药、优选品牌药、非优选品牌药有不同的层级。您通常为仿制药或优选品牌药层级的处方支付最少的费用。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '如果您服用任何常规处方药,确保您的处方在药品目录中并了解它在哪个层级总是一个好主意。',
              marks: [
                {
                  type: 'italic',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'hr',
          content: [],
          data: {},
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '医疗服务提供者网络',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '医疗服务提供者网络是包含在健康计划网络中的医疗保健提供者和设施的列表。您的健康计划将帮助承保您从"网络内"提供者那里产生的费用,但如果您从网络外提供者那里获得医疗护理,您的健康计划可能承保较少的费用或根本不承保这些费用。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '如果您有任何经常去的医疗保健提供者或地点,请确保在加入健康计划之前检查它们是否在网络内。在许多情况下,网络内提供者较少的计划收取较低的保费。这可以为您提供省钱的机会,但这可能意味着您需要更换医生以确保您的计划将帮助承保您的医疗账单。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    waive_coverage_modal: {
      title: '已放弃健康计划',
      disclaimer: '您可以随时返回更新您的计划。',
      description: '您已决定放弃健康保险。您可以随时返回此页面并选择其他健康计划来更改此决定。',
      loadingText: '正在放弃您的健康计划',
    },
    premium_cost_receipt: {
      yearlyCost: '年度费用',
      premiumCosts: '保费成本',
      yearlyPremiums: '年度保费',
      yearlyMultiplier: '年度乘数',
    },
    plan_tips: {
      ranking: {
        text: {
          p1: '根据您提供的医疗保健需求和偏好信息,我们评估了每个计划的费用和保障范围,并为您找到了最佳匹配方案。',
          p2: '在评估价值时,我们会考察您可能获得的保障范围以及您将为每个计划支付的保费。为了估算您可能获得的保障,我们使用实际医疗理赔数据模拟像您这样的人在每个计划中的体验,然后根据您对风险偏好问题的回答来评估您从额外风险保护中获得的价值。',
          p3: '需要注意的是,即使您强烈偏好风险保护,您的最佳价值选择可能仍然是保障范围较低的计划。这可能是因为您面临的风险不大,或者因为高保障选项的定价过高,以至于它们永远不会是一个好的选择。',
        },
        underline: '这些计划是如何排名的?',
      },
      bestMatch: {
        text: '根据您的偏好、计划详情和预测的医疗保健费用,我们确定此计划最适合您{x}。',
        title: '您的最佳匹配',
        underline: '您的最佳匹配!',
      },
      colorTiers: {
        redText: '此计划看起来不太适合您,您最终通过此计划省钱的可能性很低。',
        redTitle: '红色评级',
        greenText: '根据您预测的医疗保健需求和偏好,此计划看起来很适合您。',
        greenTitle: '绿色评级',
        yellowText: '此计划看起来比较适合您,但如果您选择绿色评级的计划,可能会获得更好的价值。',
        yellowTitle: '黄色评级',
      },
      hsaMatching: {
        text: '如果您选择此计划,您的雇主将匹配您向HSA缴纳金额的{matchPercent}%,最高可达{matchLimit}。您可以用这笔钱帮助支付医疗账单,未使用的部分归您所有。',
        title: '这是什么意思?',
        underline: '匹配您缴纳金额的{matchPercent}%(最高{matchLimit})',
      },
      hraContribution: {
        text: '如果您选择此计划,您的雇主将通过HRA报销最高{x}的费用。您可以用这笔钱帮助支付医疗账单。',
        title: '这是什么意思?',
        underline: '向您的HRA报销最高{x}',
      },
      hraIntroduction: {
        text: '健康报销安排(HRA)是由您的雇主设立的支出账户,用于帮助支付保险不承保的医疗费用。如果您的雇主设立了HRA,您可以提交已支付医疗账单的收据,您的雇主将报销这些费用,直到您用完所有分配的资金。您未使用的任何HRA资金将在年底返还给您的雇主,但您的雇主可能允许您将部分HRA资金结转到下一年。',
        title: '健康报销账户(HRA)',
      },
      hsaContribution: {
        text: '如果您选择此计划,您的雇主将向您的HSA缴纳最高{x}的金额。您可以用这笔钱帮助支付医疗账单,未使用的部分归您所有。',
        underline: '向您的HSA缴纳最高{x}',
      },
      hsaIntroduction: {
        text: 'HSA是特殊账户,允许您储蓄和投资资金以支付医疗保健费用。您无需为HSA的缴款、收益或提款缴税,这种三重税收优惠使其成为现在和未来为医疗保健费用储蓄的最佳方式。个人每年最多可缴纳{x}(55岁或以上的个人可能有资格额外缴纳1,000美元的补缴款),家庭在2022年每年最多可缴纳{x}。一旦您储蓄达到HSA管理机构的最低储蓄要求,您就可以投资积累的任何超额资金。',
        title: '健康储蓄账户(HSA)',
      },
      sihraContribution: {
        text: '如果您选择由您配偶雇主提供的此SIHRA合格健康计划,您的雇主将向该账户缴纳最高{x}的金额。您可以用这笔钱帮助支付医疗账单。',
        title: '这是什么意思?',
        underline: '向您的SIHRA缴纳最高{x}',
      },
      sihraIntroduction: {
        text: '配偶激励健康报销安排(SIHRA)是由您的雇主设立的支出账户,用于帮助支付保险不承保的医疗费用。如果您的雇主设立了SIHRA,您可以提交已支付医疗账单的收据,您的雇主将报销这些费用,直到您用完所有分配的资金。您未使用的任何SIHRA资金将在年底返还给您的雇主,但您的雇主可能允许您将部分SIHRA资金结转到下一年。',
        title: '配偶激励健康报销账户(SIHRA)',
      },
    },
  },
};
